import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-paper px-5 py-20 sm:py-24 lg:px-8" aria-labelledby="faq" data-id="element-94" data-mp="1lcafxcu66n62">
      <div className="mx-auto max-w-3xl" data-id="element-95" data-mp="1ge0ewllrkscj">
        <h2 id="faq" className="display text-3xl text-ink sm:text-4xl" data-id="element-96" data-mp="2e0fypu1ny239">
          Preguntas rápidas
        </h2>

        <ul className="mt-10 divide-y divide-paper-line border-t border-paper-line" data-id="element-97" data-mp="291mku0igs92k">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.q} data-id="element-98" data-mp="24433usudti6x" data-mpi={i}>
                <h3 data-id="element-99" data-mp="1z3yox794gvit">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-5 text-left text-ink transition-colors duration-150 ease-out hover:text-grass focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grass" data-id="element-100" data-mp="1z2dudhmt5cky">
                    <span className="text-lg font-bold text-inherit" data-id="element-101" data-mp="fjry8z34qpng">{faq.q}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-grass transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-102" data-mp="fm4ftb4z6xzz" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-103" data-mp="3sywqu9mvuifr">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-104" data-mp="1sd53zfid82o">
                      <p className="pb-6 pr-10 text-[15px] leading-relaxed text-ink-soft" data-id="element-105" data-mp="1uifhzo6ldyph">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}